export default function(amount) {
    if (typeof amount === 'string') amount = Number(amount);
    let p = amount.toFixed(2).split('.');
    return p[0].split("").reverse().reduce(function(acc, num, i, orig) {
        return num + (num != "-" && i && !(i % 3) ? "," : "") + acc;
    }, "") + "." + p[1];
}